import React from 'react'
import { handleWhatsAppClick } from '../whatsappClickTrack'

function Whatsapp() {
    return (
        <div className="container cta-block-wide sec-pad">
            <div className="row justify-content-center text-center">
                <div className="col-lg-10 vcenter">
                    <div className="cta-heading-wide-bt">
                        <h3>Contact us now on <span className="ree-text rt40">Whatsapp</span></h3>
                        <a href="https://wa.me/917796614664" className="ree-btn whatsapp-bg mw-80 " target="blank" onClick={handleWhatsAppClick}><i className='fab fa-whatsapp'></i> +91 77 966 146 64</a>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Whatsapp